import React from "react";

const JQuery_Chaining = () => {
  return (
    <div>
      <h1>JQuery_Chaining</h1>
      <p>Placeholder component for: "JQuery_Chaining"</p>
    </div>
  );
};

export default JQuery_Chaining;
